import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/contact";

export const WhatsAppFloat = () => (
  <motion.a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 2.6, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.94 }}
    className="fixed bottom-6 right-6 z-50 group flex items-center gap-0 bg-emerald-500 text-[#0B0F17] rounded-full shadow-[0_0_30px_rgba(16,185,129,0.4)] overflow-hidden"
    data-testid="whatsapp-chat-button"
    aria-label="Chat on WhatsApp"
  >
    <span className="relative flex items-center justify-center w-14 h-14">
      <span className="absolute inset-0 rounded-full bg-emerald-400 animate-pulse-amber opacity-40" />
      <MessageCircle className="w-6 h-6 relative" />
    </span>
    <span className="max-w-0 group-hover:max-w-[180px] transition-all duration-500 ease-out whitespace-nowrap font-display font-bold tracking-widest uppercase text-sm overflow-hidden">
      <span className="pr-5 pl-1">Chat with Bhargav</span>
    </span>
  </motion.a>
);
